import type * as mosaicModels from '../../../../models'
import type * as models from '../../models'

export interface State {
  lookup: State.WidgetLookup
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    lookup: {},
  }

  /**
   * Stores {@link models.widget.Preview} by
   * {@link mosaicModels.widget.Ref.Id}
   *
   * @see {@link WidgetLookup.Entry}
   */
  export type WidgetLookup = Partial<
    Record<mosaicModels.widget.Ref.Id, WidgetLookup.Entry>
  >
  export namespace WidgetLookup {
    /**
     * Represents a {@link models.widget.Preview}
     */
    export interface Entry {
      preview?: models.widget.Preview
      isLoading?: boolean
      error?: Error
    }
  }
}
